/* eslint-disable no-shadow,no-param-reassign */

const initialState = {
  upcoming: {},
  unsigned: {},
  completed: {},
  patients: {},
  providers: {},
  showScheduler: false,
  interviewImages: {}
};

export const state = initialState;

export const getters = {
  upcoming: state => state.upcoming,
  unsigned: state => state.unsigned,
  completed: state => state.completed,
  patient: state => id => state.patients[id],
  provider: state => id => state.providers[id],
  showScheduler: state => state.showScheduler,
  getUpcoming: state => id => state.upcoming[id]
};

export const actions = {
  setUpcoming({ commit }, payload) {
    commit("setUpcoming", payload);
  },
  setUnsigned({ commit }, payload) {
    commit("setUnsigned", payload);
  },
  setCompleted({ commit }, payload) {
    commit("setCompleted", payload);
  },
  toggleScheduler({ commit }, payload) {
    commit("toggleScheduler", payload);
  }
};

export const mutations = {
  setUpcoming(state, data) {
    state.upcoming = Object.assign({}, data.list.encounters);
    state.patients = Object.assign({}, state.patients, data.list.patients);
    state.providers = Object.assign({}, state.providers, data.list.users);
  },

  setUnsigned(state, data) {
    state.unsigned = Object.assign({}, data.list.encounters);
    state.patients = Object.assign({}, state.patients, data.list.patients);
    state.providers = Object.assign({}, state.providers, data.list.users);
  },

  setCompleted(state, data) {
    // if (state.nextPage === 1) {
    //   state.queue = Object.assign({}, data.list.patientQueues);
    // } else {
    //   state.queue = Object.assign({}, state.queue, data.list.patientQueues);
    // }

    // let nextPage = 1;
    // let morePages = false;
    // if (_.has(data.links, 'next')) {
    //   const matches = data.links.next.match(/page%5Bnumber%5D=(\d+)&/);
    //   nextPage = matches[1];
    //   morePages = true;
    // }

    // state.nextPage = nextPage;
    // state.morePages = morePages;

    state.completed = Object.assign({}, data.list.encounters);
    state.patients = Object.assign({}, state.patients, data.list.patients);
    state.providers = Object.assign({}, state.providers, data.list.users);
  },

  toggleScheduler(state, show) {
    state.showScheduler = show;
  }
};
